export default "__VITE_ASSET__Nkw$MgPt__"